// ******************  DO NOT USE this model ****************/

// this is automatically configured in the collection manager ***/



// Model used by generic_collection
// extend this model if specific functionality is required (i.e. validation)
define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		idAttribute: '_appId'
	});

});
